<table class="table" [class.table-clickable]="!folderContentTemplate">
  <tbody>
    <ng-container *ngIf="displayFolders && displayFolders.length > 0">
      <ng-container
        *ngTemplateOutlet="
          navi;
          context: {
            paths: displayFolders,
            parentKey: '__root',
            level: 1,
            ancestorKeys: []
          }
        "
      ></ng-container>
    </ng-container>
  </tbody>
</table>
<ng-template
  #navi
  let-paths="paths"
  let-parentKey="parentKey"
  let-level="level"
  let-ancestorKeys="ancestorKeys"
>
  <ng-container *ngFor="let path of paths; let i = index">
    <ng-container
      [ngTemplateOutlet]="rowTemplate"
      [ngTemplateOutletContext]="{
        path: path,
        rowKey: parentKey + '_colLevel' + level + '-' + i,
        parentKey: parentKey,
        level: level,
        i: i,
        ancestorKeys: (ancestorKeys || []).concat(parentKey)
      }"
    >
    </ng-container>
  </ng-container>
</ng-template>

<ng-template
  #rowTemplate
  let-path="path"
  let-rowKey="rowKey"
  let-parentKey="parentKey"
  let-level="level"
  let-i="i"
  let-ancestorKeys="ancestorKeys"
>
  <tr
    [attr.id]="idPrefix + '_' + path.path"
    [attr.data-parent]="parentKey"
    [class]="
      'tablist-list ' +
      (isAnyAncestorCollapsed(ancestorKeys || []) ? 'd-none ' : '') +
      rowKey
    "
    [class.selected]="selectedPath === path.path"
    class="cursor-pointer"
  >
    <td
      [attr.colspan]="projectedColumns"
      (click)="
        folderContentTemplate
          ? toggleCollapse(rowKey, $event)
          : onSelectPath(path)
      "
    >
      <div
        [style.margin-left]="'calc(1em * ' + level + ')'"
        class="position-relative"
      >
        <button
          (click)="toggleCollapse(rowKey, $event)"
          class="btn btn-link btn-sm position-absolute"
          style="left: -30px; top: -3px"
          type="button"
        >
          <i
            *ngIf="
              (path.subFolders && path.subFolders.length) ||
              folderContentTemplate
            "
            class="fa-regular fa-chevron-right fa-fw float-left mt-1 mr-1"
            [style.transform]="
              'rotate(' + (isCollapsed(rowKey) ? 0 : 90) + 'deg)'
            "
          ></i>
        </button>
        <div class="w-100">{{ path.name }}</div>
      </div>
    </td>
    <td *ngIf="showNewSubPathButton" width="1%">
      <button
        (click)="emitNewSubPath(path)"
        type="button"
        class="btn btn-outline-secondary btn-sm"
      >
        <i class="fa-regular fa-plus fa-fw"></i>
      </button>
    </td>
  </tr>
  <ng-container *ngIf="folderContentTemplate">
    <ng-container
      *ngTemplateOutlet="folderContentTemplate; context: { $implicit: path }"
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="path.subFolders && path.subFolders.length">
    <ng-container
      *ngTemplateOutlet="
        navi;
        context: {
          paths: path.subFolders,
          parentKey: rowKey,
          level: level + 1,
          ancestorKeys: (ancestorKeys || []).concat(parentKey)
        }
      "
    ></ng-container>
  </ng-container>
</ng-template>
